export default __webpack_public_path__ + "static/media/@achadissimosoficial.42280f27.jpg";